<template>
    <v-container>
        <v-row class="mt-4 text-h6" justify="center">
            <v-col cols="10" xl="8">
                <div class="heading text-h4 pl-4">Q&A</div>
            </v-col>
        </v-row>
        
        <div class="chat-container">
            <div class="chat-messages">

                <div v-for="(message, index) in messages" :key="index">

                    <!-- botのメッセージ -->
                    <div v-if="message.type === 'bot'" class="bot-message">
                        {{ message.text }}
                    </div>

                    <!-- teacherとstudentのメッセージ -->
                    <v-row v-else class="message-row">
                        <v-col cols="10">
                            <!-- メッセージテキスト -->
                            <div :class="message.type === 'teacher' ? 'teacher-message' : 'student-message'">
                                {{ message.text }}
                            </div>
                        </v-col>

                        <v-col cols="2">
                            <!-- アイコン -->
                            <v-avatar :class="message.type === 'teacher' ? 'teacher-icon' : 'student-icon'">
                                <!-- <v-icon>{{ message.type === 'teacher' ? 'mdi-account-circle' : 'mdi-account' }}</v-icon> -->
                                <v-img v-if="message.type === 'teacher'" src="@/assets/profile_image/default_profile_icon.png"></v-img>
                                <v-icon v-else>mdi-account-school</v-icon> 
                            </v-avatar>
                        </v-col>
                    </v-row>

                </div>
            </div>
        </div>

    </v-container>
</template>

<script>
import questions from './data/questions.js'
export default {
  data() {
    return {
      messages: questions.messages,
    };
  },
};
</script>

<style scoped>
.heading {
  border-bottom: 2px solid #000;
}

.chat-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message-row {
  max-width: 70%;
  align-self: flex-end; /* teacherとstudentのメッセージを右寄せにする */
  margin-left:auto;
}

.teacher-icon {
  background-color: #f0f0f0;
  color: white;
}

.student-icon {
  background-color: #f0f0f0;
  color: white;
}

.bot-message {
  max-width: 70%;
  background-color: #002884;
  color: white;
  padding: 10px;
  border-radius: 10px;
  align-self: flex-start; /* botのメッセージを左寄せにする */
}

.teacher-message {
  background-color: #f0f0f0;
  color: black;
  padding: 10px;
  border-radius: 10px;
}

.student-message {
  background-color: #f0f0f0;
  color: black;
  padding: 10px;
  border-radius: 10px;
}
</style>
